<template>
    <div v-show="isLoaded" class="mMaridajeRed-container" v-observe-visibility="startAnimate">
        <div class="brushRed-background">
            <h2 class="mSection-title" :class="{animate: animate}">Maridaje</h2>
            <p class="mSection-subtitle" :class="{animate: animate}">Disfruta de los platillos ideales para maridar con Strongbow Red Berries, abriendo los sentidos a vivir su máximo sabor.</p>
        </div>
        <div class="img-container">
            <img class="img-maridaje" :src="maridaje" alt="Maridaje Red">
            <div class="stick"></div>
            <div class="point"></div>
        </div>
        <div class="mfeature feature-botana" v-observe-visibility="startAnimate1">
            <div class="red-box feature-botana" :class="{animate: animate1}"></div>
            <h3 class="feature-title" :class="{animate: animate1}">Con <br>Botana</h3>
            <ul class="list-feature">
                <li>Frutos secos, pistaches y almendras.</li>
                <br>
                <li>Pan horneado con frutas, nueces y semillas.</li>
                <br>
                <li>Papas fritas ligeramente condimentadas.</li>
            </ul>
        </div>
        <div class="mfeature feature-quesos" v-observe-visibility="startAnimate2">
            <div class="red-box feature-quesos" :class="{animate: animate2}"></div>
            <h3 class="feature-title" :class="{animate: animate2}">Con <br>quesos</h3>
            <ul class="list-feature">
                <li>De textura cremosa y sabores semi maduros (cabra, oveja) manchego y gouda, etc.</li>
            </ul>
        </div>
        <div class="mfeature feature-calientes" v-observe-visibility="startAnimate3">
            <div class="red-box feature-calientes" :class="{animate: animate3}"></div>
            <h3 class="feature-title" :class="{animate: animate3, onlySafari: isSafari}">Con platos calientes</h3>
            <ul class="list-feature">
                <li>Hamburguesa con queso.</li>
                <li>Pollo o pechuga de pato, preparados con salsa a base de frutas.</li>
            </ul>
        </div>
        <div class="mfeature feature-frios" v-observe-visibility="startAnimate4">
            <div class="red-box feature-frios" :class="{animate: animate4}"></div>
            <h3 class="feature-title" :class="{animate: animate4}">Con platos <br>frios</h3>
            <ul class="list-feature">
                <li>Jamón serrano o charcutería curada.</li>
                <br>
                <li>Sushi o sashimi.</li>
                <br>
                <li>Ensaladas con frutas, carnes blancas o pescado fresco.</li>
                <br>
                <li>Ceviches preparados con frutas.</li>
            </ul>
        </div>
        <div class="mfeature feature-postres" v-observe-visibility="startAnimate5">
            <div class="red-box feature-postres" :class="{animate: animate5}"></div>
            <h3 class="feature-title" :class="{animate: animate5}">Con <br>postres</h3>
            <ul class="list-feature">
                <li>Cremas con frutos rojos.</li>
                <br>
                <li>Tartaletas de frambuesa y cheesecake.</li>
                <br>
                <li>Gelatinas cremosas con frutos rojos (panacotta, mousse).</li>
            </ul>
        </div>
    </div>
</template>

<script>
import maridaje from "@/assets/red-berries/maridaje_red.png"
import Bowser from "bowser"; 
import { mapGetters } from "vuex";
export default {
    name: "MaridajeRed",
    components: {},
    data() {
        return {
            maridaje,
            animate: false,
            animate1: false,
            animate2: false,
            animate3: false,
            animate4: false,
            animate5: false,
            isSafari: false
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        },
        startAnimate1(isVisible) {
            if(isVisible) {
                this.animate1=true
            }
        },
        startAnimate2(isVisible) {
            if(isVisible) {
                this.animate2=true
            }
        },
        startAnimate3(isVisible) {
            if(isVisible) {
                this.animate3=true
            }
        },
        startAnimate4(isVisible) {
            if(isVisible) {
                this.animate4=true
            }  
        },
        startAnimate5(isVisible) {
            if(isVisible) {
                this.animate5=true
            }  
        },
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/RedBerries/MaridajeRed.scss";
</style>